(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["local-edition-status"] && !Shopify.designMode) return;
  try {
    (function(){
  function oaCountSync(){
    document.querySelectorAll('[data-oa-count]').forEach(function(box){
      var el = box.parentElement;
      while (el && !el.querySelector('variant-picker')) el = el.parentElement;
      if (!el) return;
      var pk = el.querySelector('variant-picker');
      var val = '';
      var fs = pk.querySelector('fieldset');
      if (fs) { var c = fs.querySelector('input:checked'); if (c) val = c.value; }
      else { var s = pk.querySelector('select'); if (s) val = s.value; }
      var code = (val || '').trim().split(' ')[0].toUpperCase();
      if (!code || !box.querySelector('[data-oa-f="' + code + '"]')) return;
      box.querySelectorAll('[data-oa-f]').forEach(function(p){ p.hidden = p.getAttribute('data-oa-f') !== code; });
    });
  }
  document.addEventListener('change', function(){ setTimeout(oaCountSync, 0); setTimeout(oaCountSync, 500); });
  document.addEventListener('shopify:section:load', oaCountSync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', oaCountSync); else oaCountSync();
})();
  } catch(e) { console.error(e); }
})();

})();
